import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles(({ spacing }) => ({
  button: {
    padding: spacing(2),
  },
}));
